import Vue from 'vue';
import Router from 'vue-router';

Vue.use(Router);

export default new Router({
    // mode: 'history',
    routes: [
        {
            path: '/',
            name: 'root',
            redirect: '/dashboard',
            component: resolve => require(['@/pages/dashboard'], resolve)
        },
        {
            path: '/dashboard',
            name: '首页',
            component: resolve => require(['@/pages/dashboard'], resolve)
        },
        {
            path: '/activity/main',
            name: '活动管理',
            component: resolve => require(['@/pages/activity/main'], resolve),
            meta: {
                keepAlive: true
            }
        },
        {
            path: '/activity/create',
            name: '创建活动',
            component: resolve => require(['@/pages/activity/create'], resolve)
        },
        {
            path: '/activity/update',
            name: '编辑活动',
            component: resolve => require(['@/pages/activity/update'], resolve)
        },
        {
            path: '/activity/detail',
            name: '查看活动',
            component: resolve => require(['@/pages/activity/detail'], resolve)
        },
        {
            path: '/activity/extension',
            name: '活动场次',
            component: resolve => require(['@/pages/activity/extension'], resolve),
            meta: {
                keepAlive: true
            }
        },
        {
            path: '/activity/extensionView',
            name: '场次',
            component: resolve => require(['@/pages/activity/extensionView'], resolve)
        },
        {
            path: '/signup/list',
            name: '报名管理',
            component: resolve => require(['@/pages/signup/list'], resolve),
            meta: {
                keepAlive: true
            }
        },
        {
            path: '/signup/view',
            name: '查看报名',
            component: resolve => require(['@/pages/signup/view'], resolve)
        },
        {
            path: '/picture/list',
            name: '图片管理',
            component: resolve => require(['@/pages/picture/list'], resolve),
            meta: {
                // keepAlive: true
            }
        },
        {
            path: '/clue/main',
            name: '线索管理',
            component: resolve => require(['@/pages/clue/main'], resolve)
        },
        {
            path: '/material/list',
            name: '图片管理',
            component: resolve => require(['@/pages/material/list'], resolve)
        },
        {
            path: '/video/list',
            name: '视频管理',
            component: resolve => require(['@/pages/video/list'], resolve)
        },
        {
            path: '/verification/worker',
            name: '核销人员管理',
            component: resolve => require(['@/pages/verification/worker'], resolve)
        },
        {
            path: "/permission",
            name: "permission",
            component: resolve => require(['@/pages/permission'], resolve)
        }
    ],
    scrollBehavior(to, from, savedPosition) {
        if (savedPosition) {
            return savedPosition;
        } else {
            return {x: 0, y: 0};
        }
    }
});
